import { createContext, useContext } from "react";

/** true innerhalb FilterBarOrDrawer-Bottom-Sheet — Popover-Filter rendern inline statt fixed Portal */
export const FilterDrawerModeContext = createContext(false);

export function useFilterDrawerMode() {
  return useContext(FilterDrawerModeContext);
}
